<template>
<div class="h-full flex flex-col">

  <!-- <p class="mt-4 text-xs text-gray-400 uppercase">
    Step 2 of 6
  </p> -->

  <label
    for="level"
    class="text-xl text-gray-700 font-medium sm:text-2xl"
  >
    <strong>{{ enquiry.initialName }}!</strong> Any particular level?
  </label>


  <div
    v-if="loading"
    class="mt-6 text-sm text-gray-600 font-medium animate-pulse"
  >
    Loading…
  </div>

  <div
    v-else
    class="mt-6 grid grid-cols-2 gap-1 sm:grid-cols-3 md:grid-cols-4"
  >
    <button
      v-for="item of levels"
      type="button"
      @click="refinementSelected(item)"
      class="flex flex-col justify-center text-left p-2 pl-2.5 bg-gray-100 hover:bg-blue-50 rounded"
      style="min-height: 48px;"
    >
      <span class="text-sm font-semibold text-gray-800">
        {{ item.Description }}
      </span>
      <span
        v-if="item.LevelSet.Id === 'EXTRACURRICULAR' || item.LevelSet.Id === 'ENTRANCEEXAM'"
        class="text-xxs text-gray-500 italic"
      >
        {{ item.LevelSet.Description }}
      </span>
    </button>
  </div>

  <button 
    type="button" 
    @click="skip"
    class="self-start flex flex-col mt-8 text-left group"
  >
    <span class="text-sm text-blue-500 font-medium group-hover:underline">
      I’m not sure
    </span>
    <span class="text-xs text-gray-500">
      Skip this step and provide details later
    </span>
  </button>


  <!-- <div class="mt-6 flex-grow flex flex-col gap-6">
    <div v-for="set of levels" class="grid gap-3" style="grid-template-columns: 30px 3fr;">
      <h2 class="my-2 flex justify-center items-center">
        <span 
          v-html="set.Description.replaceAll(' ', '<br />')"
          class="my-2 block text-xs text-gray-500 text-center uppercase transform rotate-90"
        ></span>
      </h2>

      <div 
        class="grid gap-1 sm:grid-cols-3 sm:gap-2"
        :class="[set.Id === 'MUSIC' ? 'grid-cols-2' : 'grid-cols-1']"
      >
        <button 
          v-for="level of set.Levels"
          class="px-2 py-1.5 text-sm font-semibold text-gray-800 bg-gray-100 rounded"
          style="min-height: 52px;"
        >
          {{ level.Description }}
        </button>
      </div>
    </div>
    <div
      v-for="set of levels"
      class="flex flex-col"
    >
      <h2 class="mt-3 text-xs text-gray-500 uppercase">
        {{ set.Description }}
      </h2>

      <div class="mt-1 grid gap-1 grid-cols-3">
        <button
          v-for="level of set.Levels"
          class="p-2 text-sm text-gray-800 bg-gray-100"
        >
          {{ level.Description }}
        </button>
      </div>
    </div>
  </div>


<div class="flex-grow">
    <VSelect 
      v-model="refine"
      @input="refinementSelected"
      :options="levels"
      label="Description"
      :clear-search-on-select="true"
      :placeholder="`e.g. ${levels[0].Description}`"
      class="find-a-tutor-refine flex-1 mt-4 block w-full max-w-md rounded-md border-gray-200 text-base placeholder-gray-500 shadow-sm focus:border-blue-500 focus:ring-blue-500"
    >
      <template #no-options="{ search, searching }">
        <div class="text-left pl-3">
          <template v-if="searching">
            No results found for <em>{{ search }}</em>.
          </template>
        </div>
      </template>
      <template #option="{ Description, LevelSet }">
        <span class="text-sm text-gray-800">
          {{ Description }}
        </span>
        <span class="ml-2 text-xs text-gray-400 italic">
          {{ LevelSet.Description }}
        </span>
      </template>
    </VSelect>
  </div>


<router-link
    :to="{ name: 'FindATutor-Subject' }"
    class="mt-6 mb-20 text-sm text-blue-500"
  >
    Back
  </router-link>


<div class="mt-4 grid grid-cols-2 gap-x-2 gap-y-4 sm:grid-cols-3 md:grid-cols-4">
    <div
      v-for="set of levels"
    >
      <h2 class="text-sm text-gray-500">
        {{ set.Description }}
      </h2>
      <div class="mt-1 flex flex-col gap-1">
        <button
          v-for="level of set.Levels"
          class="px-2 py-1 text-sm text-gray-800 bg-gray-100 rounded"
        >
          {{ level.Description }}
        </button>
      </div>
    </div>
    
  </div> 


  <div class="mt-4 grid grid-cols-2 gap-x-2 gap-y-4 items-end sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
    

    <div
      v-for="(item, idx) of levels"
      class="flex flex-col"
    >
      <h2
        v-if="idx === 0 || item.LevelSet.Id !== levels[idx - 1].LevelSet.Id"
        class="text-xs text-gray-500 uppercase"
      >
        {{ item.LevelSet.Description }}
      </h2>

      <button
        class="mt-1 px-3 w-full h-12 text-sm font-medium text-gray-800 bg-gray-100 rounded"
      >
        {{ item.Description }}
      </button>
    </div>
  </div>   

  
  

{{ levels }}
Level<br />
<router-link :to="{ name: 'FindATutor-Location' }">TO Location</router-link> -->



</div>
</template>
<script>

import vSelect from 'vue-select'

import SearchService from '@/services/SearchServices'

const searchService = new SearchService()


export default {
  components: {
    'VSelect': vSelect,
  },
  props: {
    enquiry: Object,
  },
  data() {
    return {
      loading: true,
      refine: null,
      levels: [],
      foo: 'Great',
    }
  },
  methods: {
    refinementSelected: function(value) { 
      this.$emit('updateEnquiry', { levelId: value.Id })
      this.$router.push({name: 'FindATutor-Location'})
    },
    skip() {
      this.$emit('updateEnquiry', { levelId: null })
      this.$router.push({name: 'FindATutor-Location'})
    },
    randomWord() {
      const random = Math.floor(Math.random() * (4 - 1))
      switch (random) {
        case 0: return 'Awesome'
        case 1: return 'Brilliant'
        case 2: return 'Amazing'
        case 3: return 'Great'
      }
    }
  },
  async mounted() {
    const response = await searchService.getLevels(this.enquiry.subjectId)
    this.levels =  response.data
    this.loading = false
  },
  created() {
    this.foo = this.randomWord()
  }
}

</script>
<style lang="scss">

.find-a-tutor-refine {

  .noDrop .vs__dropdown-menu
  {
    display: none !important;
  }

  .vs__dropdown-menu
  {
    margin-top: -10px;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }

  .vs__dropdown-toggle {
    padding: 0;
    background-color: #fff;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
    border-radius: 0.375rem !important;
  }

  .vs__search, .vs__search:focus, .vs__selected {
    margin: 0;
    padding: 8px 12px;
    line-height: 2;
  }

  .vs__selected-options {
    padding: 0;
  }

  .vs__search::placeholder {
    color: #6b7280;
  }

  .vs__open-indicator {
    display: none;
  }

  .vs__actions {
    padding: 0 12px;
  }
  
  .vs--disabled .vs__search {
    background: transparent;
  }

}

</style>